export default "__VITE_ASSET__CEtwQmVT__"